var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Alert"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.358 18.0003H4.64302C3.18703 18.0033 2.00404 16.8263 2.00001 15.3693C1.99903 14.9563 2.09602 14.5473 2.28199 14.1783L7.64002 3.45932C8.05604 2.61931 8.88904 2.06432 9.82502 2.00531C10.885 1.93831 11.883 2.51031 12.361 3.45932L17.719 14.1783C18.372 15.4823 17.843 17.0683 16.539 17.7213C16.172 17.9043 15.768 18.0003 15.358 18.0003ZM3.334 15.3623C3.34004 16.0823 3.92305 16.6633 4.64302 16.6673H15.358C16.078 16.6633 16.661 16.0823 16.667 15.3623C16.667 15.1583 16.6181 14.9573 16.526 14.7753L11.169 4.0553C10.847 3.4103 10.063 3.1483 9.41805 3.47029C9.16402 3.5963 8.95803 3.80229 8.83205 4.0553L3.47402 14.7753C3.38204 14.9573 3.334 15.1583 3.334 15.3623ZM10 5.58029C9.631 5.58029 9.33303 5.87829 9.33303 6.24629V11.5803C9.33303 11.9483 9.631 12.2463 10 12.2463C10.3681 12.2463 10.666 11.9483 10.666 11.5803V6.24629C10.666 5.87829 10.3681 5.58029 10 5.58029ZM10 13.5803C10.3681 13.5803 10.666 13.8783 10.666 14.2463C10.666 14.6153 10.3681 14.9133 10 14.9133C9.631 14.9133 9.33303 14.6153 9.33303 14.2463C9.33303 13.8783 9.631 13.5803 10 13.5803Z",
    fill: "#737188"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.e22fa21a9f44cd2424345d4ca16944e8.svg";
export { ForwardRef as ReactComponent };